import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import activity from '@/components/activity'
import news from '@/components/news'
import participating from '@/components/participating'
import newDetails from '@/components/newDetails'
import activityDetails from '@/components/activityDetails'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home,
      meta: {
        title: ' 首页'   // 标题设置
      }
    },
    // 活动
    {
      path: '/activity',
      name: 'activity',
      component: activity
    },
    {
      path: '/news',
      name: 'news',
      component: news
    },
    // 新闻
    {
      path: '/participating',
      name: 'participating',
      component: participating
    },
    // 参赛
    // 新闻详情
    {
      path: '/newDetails',
      name: 'newDetails',
      component: newDetails
    },
    // 活动详情
    {
      path: '/activityDetails',
      name: 'activityDetails',
      component: activityDetails
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js